import { UPLOADS, ebook, pdf } from '@/content/ebookBuilder'
import type { Ebook } from '@/content/ebookBuilder'

export const added: Ebook = ebook(
  'sustainability-as-a-strategic-advantage',
  'Sustainability as a Strategic Advantage: Unlocking Hidden Business Value',
  `${UPLOADS}/2024/07/Sustainability-as-a-Strategic-Advantage-1080x1080-1-400x400.jpg`,
  {
    // Its own page, built to digitopia.co's design on 2026-08-28
    // (`content/pages/ebook-sustainability-as-a-strategic-advantage.ts`). The
    // derived slug was right this time — the screenshots came from exactly
    // this address — so only the card's destination changed.
    confirmed: true,
    href: '/en/impact-labs/ebooks/sustainability-as-a-strategic-advantage',
    download: pdf(
      '3877d853-06ed-4241-9356-54d8e3af9635-Sustainability as a Strategic Advantage.pdf',
    ),
  },
)

/** Its place in the library grid — the order the imported index listed them. */
export const order = 14
